<template>
	<div class="comp-chatting-container">
		<div class="comp-chatting-c-items" v-if="chatMsg.length > 0">
			<div class="comp-chatting-c-item" :class="{'comp-chatting-c-item-select': showSelectMsg && selectMsg.indexOf(msg.id) !== -1}" v-for="msg in chatMsg" :key="'msg-'+msg.id">
				<div class="comp-chatting-c-item-system" v-if="msg.type == 'system'" v-html="msg.content">
				</div>
				<div class="comp-chatting-c-item-fans" v-else-if="msg.is_me == 0">
					<div class="comp-chatting-c-select" :class="{'comp-chatting-c-selected': selectMsg.indexOf(msg.id) !== -1}" @click="chooseMsg(msg.id)" v-if="showSelectMsg"></div>
					<div class="comp-chatting-c-avater">
						<img :src="(msg.from_photo === undefined ? chatUser.fans_wx_photo : msg.from_photo) | connectHost" alt="">
					</div>
					<div class="comp-chatting-c-box">
						<div class="comp-chatting-c-desc">
							<span class="comp-chatting-c-name">{{msg.from_name}}</span>
							<span class="comp-chatting-c-time">{{msg.send_time}}</span>
						</div>
						<div class="comp-chatting-c-msg" :class="{'comp-chatting-c-playing' : currentMsgId == msg.id && playing}">
							<div class="comp-chatting-c-msg-wrap chat-detail-msg" @click="msgClick(msg.content,msg.type,msg.id)">
								<msg-analysis :msg="msg"></msg-analysis>
							</div>
							<div class="comp-chatting-c-opt comp-chatting-c-opt-f" v-if="msg.chatType == 1">
								<ul>
									<li class="comp-chatting-copt-more" title="更多" @click="moreOpt(msg,$event,0)"></li>
								</ul>
							</div>
						</div>
						<div class="comp-chatting-quote">
							<msg-quote :msg="msg"></msg-quote>
						</div>
					</div>
				</div>
				<div class="comp-chatting-c-item-custom" v-else-if="msg.is_me == 1">
					<div class="comp-chatting-c-select" :class="{'comp-chatting-c-selected': selectMsg.indexOf(msg.id) !== -1}" @click="chooseMsg(msg.id)" v-if="showSelectMsg"></div>
					<div class="comp-chatting-c-box">
						<div class="comp-chatting-c-desc">
							<span class="comp-chatting-c-time">{{msg.send_time}}</span>
							<span class="comp-chatting-c-name">{{chatUser.custom_wx_name}}</span>
						</div>
						<div class="comp-chatting-c-msg" :class="{'comp-chatting-c-playing' : currentMsgId == msg.id && playing}">
							<div class="comp-chatting-c-opt" v-if="showTools">
								<ul>
									<li class="comp-chatting-copt-more" title="更多" @click="moreOpt(msg,$event,1)"></li>
									<li class="comp-chatting-copt-back" title="撤回" @click="msgBack(msg)"></li>
									<li class="comp-chatting-copt-del" title="删除" @click="msgDel(msg)"></li>
								</ul>
							</div>
							<div class="comp-chatting-c-msg-status" 
								:class="{'comp-chatting-c-msg-status-fail':msg.is_send == 0,'comp-chatting-c-msg-status-load':msg.is_send == 2}" 
								v-if="msg.is_send !== 1">
							</div>
							<div class="comp-chatting-c-msg-wrap chat-detail-msg-me" @click="msgClick(msg.content,msg.type,msg.id)">
								<msg-analysis :msg="msg"></msg-analysis>
							</div>
						</div>
						<div class="comp-chatting-quote">
							<msg-quote :msg="msg"></msg-quote>
						</div>
					</div>
					<div class="comp-chatting-c-avater">
						<img :src="chatUser.custom_wx_photo | connectHost" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="comp-chatting-c-empty" v-else>
			<p>提示：当前粉丝或群没有聊天记录</p>
		</div>
		<div class="comp-chatting-co-more" id="comp-chatting-co-more" v-show="clickMsg !== ''">
			<ul>
				<li @click="saveToReply">保存到快捷语</li>
				<li @click="sendToMoment">转发到朋友圈</li>
				<li @click="transferReturnMsg">转账退回</li>
				<li class="comp-chatting-co-more-cancel" @click="clickMsg = ''">取消</li>
			</ul>
		</div>
		<audio :id="'msg-audio-'+userType" :src="audioUrl" style="display: none;"></audio>
		<shadow-comp v-if="showShadow" @shadow-close="shadowClose()" :title="toolTitle">
			<chat-info-reply-edit key="Chatting-cre" :message="clickMsg" @reply-edit-call="shadowClose()" v-if="toolType === 'reply'"></chat-info-reply-edit>
			<circle-sender-comp key="Chatting-csc" :message="clickMsg" v-if="toolType === 'moment'" @circle-sender-close="shadowClose()"></circle-sender-comp>
		</shadow-comp>
	</div>
</template>

<script>
import {webGetChatRecord,webDeleteChatRecord} from '../network/web/chat-record.js'
import {deleteChatRecordById} from '../network/local/chat-record.js'
import {pushRedPackage,pushTransferAccounts,pushMessageWithdraw,transferReturn} from '../socket/socketEventSender.js'
import {getCurrentTimestamp} from '../functions/Common.js'
import ShadowComp from './ShadowComp.vue'
import ChatInfoReplyEdit from '../views/chat/info/ChatInfoReplyEdit.vue'
import CircleSenderComp from './CircleSenderComp.vue'
import {webGetClusterRecord} from '../network/web/cluster-chat-record.js'
import MsgAnalysis from './msg-analysis/MsgAnalysis.vue'
import MsgQuote from './msg-quote/MsgQuote.vue'


export default {
  name: 'Chatting',
  components:{
	ShadowComp,
	ChatInfoReplyEdit,
	CircleSenderComp,
	MsgAnalysis,
	MsgQuote
  },
  props:{
	  chatMsg:{
		  type:Array,
		  default:[]
	  },
	  chatUser:{
		  type:Object,
		  default:function(){
			  return {}
		  }
	  },
	  allImages:{
		  type:Array,
		  default:function(){
			  return []
		  }
	  },
	  userType: {
		  type: String,
		  default: "chatting"
	  },
	  showSelectMsg:{
		  type:Boolean,
		  default:false
	  },
	  showTools:{
		  type:Boolean,
		  default:false
	  }
  },
  data(){
	  return {
		  currentMsgId: -1,
		  audioUrl: '',
		  playing: false,
		  selectMsg:[],
		  clickMsg:'',
		  showShadow: false,
		  toolType: '',
		  toolTitle: ''
	  }
  },
  methods:{
	  init(){
		  this.currentMsgId = -1
		  this.audioUrl = ''
		  this.playing = false
		  this.selectMsg = []
		  this.clickMsg = ''
		  this.showShadow = false
		  this.toolType = ''
		  this.toolTitle = ''
	  },
	  
	  // 消息点击处理
	 msgClick(content,type,id){ 
		 this.currentMsgId = id
		 // 图片类型消息点击
		 if(type === 'image'){
			 // 判断当前图片是否再所有的图片中
			 let index = this.allImages.indexOf(content)
			 let data = []
			 if(index !== -1){
				 data = this.allImages
			 }else{
				 index = 0
				 data.push(content)
			 }
			 this.$store.commit('updatePreviewFile',{
				 type:'image',
				 data:JSON.parse(JSON.stringify(data)),
				 index:index
			 })
		 }
		 // 语音类型消息点击
		 else if(type === 'voice'){
			 let voiceUrl = ''
			 try{
			 	let voiceObj = JSON.parse(content)
			 	voiceUrl = voiceObj.voiceUrl
			 }catch(e){
			 	voiceUrl = content
			 	//TODO handle the exception
			 }
			 this.playing = true
			 this.audioUrl = voiceUrl
			 let audio = document.getElementById('msg-audio-'+this.userType)
			 let _this = this
			 audio.oncanplay = function(){
				audio.play()
			 }
			 audio.onpause = function(){
				 _this.playing = false
				 _this.audioUrl = ''
			 }
		 }
		 // 红包消息-未收取时
		 else if(type === 'red_package'){
			 webGetChatRecord(id,res=>{
				 if(!res){
					 return
				 }
				 let content = JSON.parse(res.content)
				 pushRedPackage(content.nativeurl,content.paymsgid,content.content,content.fromId,content.toId,content.weiI)
			 })
		 }
		 // 转账消息，未收取时
		 else if(type === 'transfer_accounts'){
			 webGetChatRecord(id,res=>{
				if(!res){
					 return
				}
				let content = JSON.parse(res.content)	 
				pushTransferAccounts(content.invalidtime,content.paysubtype,content.transcationid,content.transferid,content.wxid,content.content,content.fromId,content.toId,content.money,content.weiI)
			 })
		 }else if(type === 'file'){
			 try{
			 	let contentObj = JSON.parse(content)
				if(contentObj.path !== undefined && contentObj.path !== ''){
					window.open(contentObj.path)
				}
			 }catch(e){
			 	//TODO handle the exception
			 }
		 }else if(type === 'link'){
			 try{
			 	let contentObj = JSON.parse(content)
				if(contentObj.link_url !== undefined && contentObj.link_url !== ''){
					window.open(contentObj.link_url)
				}
			 }catch(e){
			 	//TODO handle the exception
			 }
		 }else{
			 return
		 }
	 },
	 
	 // 消息撤回点击
	 msgBack(msg){
		 if(msg.chatType === undefined){
			 return
		 }
		 if(msg.chatType === 2){
			 // 获取服务器聊天记录
			 webGetClusterRecord(msg.id,res=>{
				 if(!res){
					 return
				 }
				 let msgId = res.msgId
				 if(msgId === undefined || msgId === null || msgId === 'null' || msgId === "0" || msgId === 0 || msgId === ''){
					 CHAT_LAYER.msg('消息参数不全，撤回失败',{icon:2})
					 return
				 }
				 if(getCurrentTimestamp() - getCurrentTimestamp(msg.send_time) >= 110000){
					 CHAT_LAYER.msg('消息发送已超过2分钟，撤回失败',{icon:2})
					 return
				 }
				 CHAT_LAYER.msg('指令推送成功，请稍后',{icon:1})
				 pushMessageWithdraw(msgId,res.id,this.chatUser.phone_id,msg.chatType)
			 })
		 }else{
			 // 获取服务器聊天记录
			 webGetChatRecord(msg.id,res=>{
				 if(!res){
					 return
				 }
				 let msgId = res.msgId
				 if(msgId === undefined || msgId === null || msgId === 'null' || msgId === "0" || msgId === 0 || msgId === ''){
					 CHAT_LAYER.msg('消息参数不全，撤回失败',{icon:2})
					 return
				 }
				 if(getCurrentTimestamp() - getCurrentTimestamp(msg.send_time) >= 110000){
					 CHAT_LAYER.msg('消息发送已超过2分钟，撤回失败',{icon:2})
					 return
				 }
				 CHAT_LAYER.msg('指令推送成功，请稍后',{icon:1})
				 pushMessageWithdraw(msgId,res.id,this.chatUser.phone_id,msg.chatType)
			 })
		 }
	 },
	 
	 // 消息删除
	 msgDel(msg){
		 if(msg.chatType === undefined){
			 return
		 }
		 let _this = this
		 CHAT_LAYER.confirm('确认要删除当前消息吗？', {
		 		btn: ['确认', '取消']
		 	},
		 	function(index, layero) {
		 		// 删除服务器端聊天记录
		 		webDeleteChatRecord(msg.id,res=>{
		 			if(!res){
		 				return
		 			}
		 			// 删除本地聊天记录
		 			deleteChatRecordById(msg.id,d_res=>{
		 				_this.$store.commit('updateOtherEvent',{
							type: 'messageDelete',
							recodeId: msg.id
						})
		 			})
		 		})
				CHAT_LAYER.close(index)
		 	},
		 	function(index) {
		 		
		 	})
	 },
	 
	 // 消息前面的选择按钮点击
	 chooseMsg(id){
		let index = this.selectMsg.indexOf(id)
		if(index === -1){
			this.selectMsg.push(id)
		}else{
			this.selectMsg.splice(index,1)
		}
		// 获取消息详情，获取消息内容，反射给父级组件
		let data = JSON.parse(JSON.stringify(this.selectMsg)).sort((a,b)=>{return a-b})
		let msgs = JSON.parse(JSON.stringify(this.chatMsg))
		let messageList = []
		if(data.length > 0){
			for (let i = 0; i < msgs.length; i++) {
				if(data.indexOf(msgs[i].id) !== -1){
					messageList.push(msgs[i])
				}
			}
		}
		this.$emit('select-msg-list',messageList)
	 },
	 
	 // 更多菜单点击
	 moreOpt(msg, event,type) {
	 	// 屏蔽默认事件
	 	event.preventDefault()
	 	// 定位
	 	var menu = document.querySelector("#comp-chatting-co-more")
	 	let appObj = document.querySelector("#chat-list")
	 	let appHeight = 800
		let appWidth = 600
	 	if (appObj !== undefined) {
	 		appHeight = appObj.clientHeight
			appWidth = appObj.clientWidth
	 	}
	 	appHeight = Math.ceil(appHeight / 2)
		appWidth = Math.ceil(appWidth / 2)
	 	// LEFT距离计算
		let minX = 480 + 120
		let maxX = document.body.clientWidth - 300 - 150
		let maxY = document.getElementById('container').clientHeight - 230 - 104
	 	let offsetX = 0
		if(type === 0){
			if(event.clientX > maxX){
				offsetX = maxX + 30
			}else {
				offsetX = event.clientX + 10
			}
		}else{
			if(event.clientX < minX){
				offsetX = event.clientX + 10
			}else {
				offsetX = event.clientX - 130
			}
		}
	 	
	 	// TOP距离计算
	 	let offSetY = 0
	 	if (event.clientY < 130) {
	 		offSetY = 130
	 	}else if(event.clientY > maxY){
			offSetY = maxY
		}else {
	 		offSetY = event.clientY - 20
	 	}
	 	menu.style.left = offsetX + 'px'
	 	menu.style.top = offSetY + 'px'
		this.clickMsg = msg
	 },
	 
	 // 保存到快捷语
	 saveToReply(){
		 this.showShadow = true
		 this.toolType = 'reply'
		 this.toolTitle = '添加快捷语'
	 },
	 
	 // 发送到朋友圈
	 sendToMoment(){
		 this.showShadow = true
		 this.toolType = 'moment'
		 this.toolTitle = '发送朋友圈'
	 },
	 
	 // 转账退回
	 transferReturnMsg(){
		 if(this.clickMsg.type !== 'transfer_accounts'){
			 CHAT_LAYER.msg('仅转账可退款',{icon:2})
			 return
		 }
		 try{
			 let content = JSON.parse(this.clickMsg.content)
			 if(content.transcationid === undefined || content.transferid === undefined || content.fromId === undefined){
				 CHAT_LAYER.msg('参数错误',{icon:2})
				 return
			 }
			 CHAT_LAYER.msg('指令推送成功，请稍后',{icon:1})
			 transferReturn(content.transcationid,content.transferid,content.fromId,this.clickMsg.id,this.chatUser.phone_id)
		 }catch(e){
			CHAT_LAYER.msg('参数解析错误',{icon:2})
		 }
		 this.shadowClose()
	 },
	 
	 // 弹框关闭
	 shadowClose(){
		 this.showShadow = false
		 this.clickMsg = ''
	 }
  },
  watch:{
	  chatUser(){
		  this.init()
	  },
	  showSelectMsg(){
		  this.selectMsg = []
	  }
  }
}
</script>

<style>
	.comp-chatting-container{
		width: 100%;
		height: auto;
		position: relative;
	}
	.comp-chatting-container .comp-chatting-c-items{
		width: 100%;
		height: auto;
		box-sizing: border-box;
	}
	.comp-chatting-c-items .comp-chatting-c-item{
		padding: 10px 20px;
		color: #333333;
	}
	.comp-chatting-c-item-select{
		background-color: #EEEEEE;
	}
	.comp-chatting-c-item .comp-chatting-c-item-system{
		font-size: 12px;
		padding: 0 50px;
		color: #999999 !important;
		text-align: center;
	}
	.comp-chatting-c-item-system > a{
		color: #007DDB;
	}
	.comp-chatting-c-item .comp-chatting-c-item-fans{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: nowrap;
	}
	.comp-chatting-c-select{
		width: 20px;
		height: 20px;
		background-image: url(../assets/img/select-out.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 20px auto;
		margin-right: 10px;
		margin-top: 10px;
		cursor: pointer;
	}
	.comp-chatting-c-selected{
		background-image: url(../assets/img/select-in.png);
	}
	.comp-chatting-c-item-fans .comp-chatting-c-avater{
		width: 40px;
		height: 40px;
		margin-right: 10px;
	}
	.comp-chatting-c-avater img{
		width: 40px;
		height: 40px;
		border-radius: 4px;
	}
	.comp-chatting-c-item-fans .comp-chatting-c-box{
		width: 0;
		height: auto;
		flex-grow: 1;
	}
	.comp-chatting-c-box .comp-chatting-c-desc{
		height: 20px;
		line-height: 20px;
		color: #999999;
		font-size: 13px;
	}
	.comp-chatting-c-desc>span{
		display: inline-block;
	}
	.comp-chatting-c-desc .comp-chatting-c-name{
		margin-right: 10px;
	}
	.comp-chatting-c-box .comp-chatting-c-msg{
		position: relative;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		white-space: normal;
		word-break: break-all;
	}
	.comp-chatting-c-msg .comp-chatting-c-msg-wrap{
		max-width: 80%;
	}
	.comp-chatting-c-msg .comp-chatting-c-msg-status{
		width: 16px;
		height: 16px;
		margin: 0 5px;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		cursor: pointer;
	}
	.comp-chatting-c-msg-status-load{
		background-image: url(../assets/img/loading-2.gif);
	}
	.comp-chatting-c-msg-status-fail{
		background-image: url(../assets/img/fail.png);
	}
	.comp-chatting-c-msg:hover .comp-chatting-c-opt{
		display: block;
	}
	.comp-chatting-c-msg .comp-chatting-c-opt{
		margin-right: 5px;
		display: none;
	}
	.comp-chatting-c-msg .comp-chatting-c-opt-f{
		margin-right: 0;
		margin-left: 5px;
	}
	.comp-chatting-c-opt ul{
		display: flex;
		justify-content: flex-start;
		border: 1px solid #dedede;
		border-radius: 2px;
		height: 22px;
	}
	.comp-chatting-c-opt ul li{
		width: 22px;
		height: 22px;
		overflow: hidden;
		border-right: 1px solid #dedede;
		background-size: 16px auto;
		background-position: center;
		background-repeat: no-repeat;
		cursor: pointer;
	}
	.comp-chatting-c-opt ul li:last-child{
		border-right: none;
	}
	.comp-chatting-c-opt .comp-chatting-copt-back{
		background-image: url(../assets/img/back-70-32.png);
	}
	.comp-chatting-c-opt .comp-chatting-copt-del{
		background-image: url(../assets/img/del-70-32.png);
	}
	.comp-chatting-c-opt .comp-chatting-copt-more{
		background-image: url(../assets/img/more-70-48.png);
	}
	.comp-chatting-c-opt ul li:hover{
		background-color: #dedede;
	}
	.comp-chatting-c-item .comp-chatting-c-item-custom{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;
		flex-wrap: nowrap;
	}
	.comp-chatting-c-item-custom .comp-chatting-c-avater{
		width: 40px;
		height: 40px;
		margin-left: 10px;
	}
	.comp-chatting-c-item-custom .comp-chatting-c-box{
		width: 0;
		height: auto;
		flex-grow: 1;
		text-align: right;
	}
	.comp-chatting-c-item-custom>.comp-chatting-c-box>.comp-chatting-c-desc>.comp-chatting-c-name{
		margin-left: 10px;
		margin-right: 0;
	}
	.comp-chatting-c-item-custom>.comp-chatting-c-box>.comp-chatting-c-msg{
		justify-content:flex-end;
	}
	.comp-chatting-co-more{
		width: 120px;
		height: auto;
		padding: 10px 0;
		background-color: #ffffff;
		line-height: 28px;
		position: fixed;
		top: 0;
		left: 0;
		border-radius: 4px;
		box-shadow: 0 1px 3px 1px #c6c6c6;
		font-size: 12px;
		user-select: none;
		z-index: 1;
	}
	.comp-chatting-co-more ul li{
		padding: 0 10px;
		cursor: pointer;
	}
	.comp-chatting-co-more ul li:hover{
		background-color: #ebebeb;
	}
	/* 消息解析样式-语音消息*/
	.chat-detail-msg .chat-voice{
		width: 60px;
	}
	.chat-detail-msg .voice{
		display: inline-block;
		height: 22px;
		width: 22px;
		background: url("/img/icon.png") -200px -432px;
		vertical-align: middle;
		cursor: pointer;
	}
	.comp-chatting-c-playing > .chat-detail-msg .voice{
		background: url("/img/playing_receive_voice.gif") 0 0 !important;
	}
	.chat-detail-msg-me .chat-voice{
		width: 60px;
		text-align: right;
	}
	.chat-detail-msg-me .voice{
		display: inline-block;
		height: 22px;
		width: 22px;
		background: url("/img/icon.png") -464px -398px;
		vertical-align: middle;
		cursor: pointer;
	}
	.comp-chatting-c-playing > .chat-detail-msg-me .voice{
		background: url("/img/playing_send_voice.gif") 0 0 !important;
	}
	/* 消息解析样式-小程序 */
	.chat-mssage{
		max-width: 350px;
		overflow: hidden;
	}
	.chat-program {
		width: 220px;
		height: auto;
		background-color: #ffffff;
		cursor: pointer;
	}
	.chat-program .chat-program-title{
		height: 20px;
		padding: 5px;
		font-size: 12px;
		color: #999999;
	}
	.chat-program-title > *{
		display: inline-block;
		height: 20px;
		line-height: 20px;
		vertical-align: middle;
	}
	.chat-program-title img{
		width: 20px;
		border-radius: 10px;
	}
	.chat-program-title span{
		margin-left: 5px;
		width: 125px;
		overflow: hidden;
	}
	.chat-program-desc{
		line-height: 20px;
		height: 20px;
		overflow: hidden;
		padding: 0 5px;
		margin-bottom: 5px;
	}
	.chat-program-big{
		width: 100%;
		padding: 0 5px 5px 5px;
		box-sizing: border-box;
	}
	.chat-program-big > img{
		width: 100%;
		height: auto;
	}
	.chat-program-footer{
		border-top: 1px solid #e2e2e2;
		color: #999999;
		font-size: 12px;
		margin: 0 5px;
	}
	.chat-program-footer span{
		display: inline-block;
		height: 16px;
		line-height: 16px;
		vertical-align: middle;
	}
	.chat-program-footer .chat-program-link{
		width: 16px;
		background-image: url(/img/link2.png);
		background-size: 15px 15px;
		background-repeat: no-repeat;
		background-position: center;
		margin-right: 5px;
	}
	/*聊天记录-红包消息*/
	.red-package{
	    background: #ffffff;
	    position: relative;
	    cursor: pointer;
	    border-radius: 4px;
	    min-width: 200px;
		border: 1px solid #e8e8e8;
	}
	.red-package .red-package-info{
	    background-image: -moz-linear-gradient(to left,#f9a243,#f57e52);
	    background-image: -o-linear-gradient(to left,#f9a243,#f57e52);
	    background-image: -webkit-linear-gradient(to left,#f9a243,#f57e52);
	    background-image: linear-gradient(to left,#f9a243,#f57e52);
	    height: 60px;
	    line-height: 60px;
	    display: flex;
	    flex-direction:row;
	    flex-wrap: nowrap;
	    justify-content: left;
	    align-items:center;
	    align-content: flex-start;
	    padding: 0 5px;
	    border-radius: 4px 4px 0 0;
	}
	.red-package-info span{
	    display: block;
	    min-width: 30px;
	    max-width: 200px;
	    max-height: 60px;
	    overflow: hidden;
	    padding: 0 5px;
	    color: #ffffff;
	}
	.red-package-info .red-package-img{
	    width: 32px;
	    height: 32px;
	    padding: 0;
	    margin-right:5px;
	    margin-left:5px;
	    overflow: hidden;
	    background: url("/img/red_package.png") no-repeat;
	    background-size:32px 32px;
	}
	.red-package .red-package-footer{
	    height: 20px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666666;
	    text-indent: 8px;
	}
	/*聊天记录-红包消息-已收*/
	.red-package-d{
	    background: #ffffff;
	    position: relative;
	    border: 1px solid #e8e8e8;
	    cursor: pointer;
	    border-radius: 4px;
	    min-width: 200px;
	}
	.red-package-d .red-package-d-info{
	    background-image: -moz-linear-gradient(to left,#fbe3ca,#ffa685);
	    background-image: -o-linear-gradient(to left,#fbe3ca,#ffa685);
	    background-image: -webkit-linear-gradient(to left,#fbe3ca,#ffa685);
	    background-image: linear-gradient(to left,#fbe3ca,#ffa685);
	    height: 60px;
	    line-height: 60px;
	    display: flex;
	    flex-direction:row;
	    flex-wrap: nowrap;
	    justify-content: left;
	    align-items:center;
	    align-content: flex-start;
	    padding: 0 5px;
	    border-radius: 4px 4px 0 0;
	}
	.red-package-d-info span{
	    display: block;
	    min-width: 30px;
	    max-width: 200px;
	    max-height: 60px;
	    overflow: hidden;
	    padding: 0 5px;
	    color: #ffffff;
	}
	.red-package-d-info .red-package-d-img{
	    width: 32px;
	    height: 32px;
	    padding: 0;
	    margin-right:5px;
	    margin-left:5px;
	    overflow: hidden;
	    background: url("/img/red_package_d.png") no-repeat;
	    background-size:32px 32px;
	}
	.red-package-d-info .red-package-d-text{
	    line-height: 18px;
	    height: 36px;
	    overflow: hidden;
	}
	.red-package-d .red-package-d-footer{
	    height: 20px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666666;
	    text-indent: 8px;
	}
	/*聊天记录-转账消息*/
	.transfer-accounts{
	    background: #ffffff;
	    position: relative;
	    border: 1px solid #e8e8e8;
	    cursor: pointer;
	    border-radius: 4px;
	    min-width: 200px;
	}
	.transfer-accounts .transfer-accounts-info{
	    background-image: -moz-linear-gradient(to left,#f9a243,#fd6b34);
	    background-image: -o-linear-gradient(to left,#f9a243,#fd6b34);
	    background-image: -webkit-linear-gradient(to left,#f9a243,#fd6b34);
	    background-image: linear-gradient(to left,#f9a243,#fd6b34);
	    height: 60px;
	    line-height: 60px;
	    display: flex;
	    flex-direction:row;
	    flex-wrap: nowrap;
	    justify-content: left;
	    align-items:center;
	    align-content: flex-start;
	    padding: 0 5px;
	    border-radius: 4px 4px 0 0;
	}
	.transfer-accounts-info span{
	    display: block;
	    min-width: 30px;
	    max-width: 200px;
	    max-height: 60px;
	    overflow: hidden;
	    padding: 0 5px;
	    color: #ffffff;
	}
	.transfer-accounts-info .transfer-accounts-img{
	    width: 32px;
	    height: 32px;
	    padding: 0;
	    margin-right:5px;
	    margin-left:5px;
	    overflow: hidden;
	    background: url("/img/transfer_accounts.png") no-repeat;
	    background-size:32px 32px;
	}
	.transfer-accounts-info .transfer-accounts-text{
	    line-height: 18px;
	    height: 36px;
	    overflow: hidden;
	}
	.transfer-accounts .transfer-accounts-footer{
	    height: 20px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666666;
	    text-indent: 10px;
	}
	/*聊天记录-转账消息-已收*/
	.transfer-accounts-d{
	    background: #ffffff;
	    position: relative;
	    border: 1px solid #e8e8e8;
	    cursor: pointer;
	    border-radius: 4px;
	    min-width: 200px;
	}
	.transfer-accounts-d .transfer-accounts-d-info{
	    background-image: -moz-linear-gradient(to left,#ffd19f,#ff9770);
	    background-image: -o-linear-gradient(to left,#ffd19f,#ff9770);
	    background-image: -webkit-linear-gradient(to left,#ffd19f,#ff9770);
	    background-image: linear-gradient(to left,#ffd19f,#ff9770);
	    height: 60px;
	    line-height: 60px;
	    display: flex;
	    flex-direction:row;
	    flex-wrap: nowrap;
	    justify-content: left;
	    align-items:center;
	    align-content: flex-start;
	    padding: 0 5px;
	    border-radius: 4px 4px 0 0;
	}
	.transfer-accounts-d-info span{
	    display: block;
	    min-width: 30px;
	    max-width: 200px;
	    max-height: 60px;
	    overflow: hidden;
	    padding: 0 5px;
	    color: #ffffff;
	}
	.transfer-accounts-d-info .transfer-accounts-d-img{
	    width: 32px;
	    height: 32px;
	    padding: 0;
	    margin-right:5px;
	    margin-left:5px;
	    overflow: hidden;
	    background: url("/img/transfer_accounts_d.png") no-repeat;
	    background-size:32px 32px;
	}
	.transfer-accounts-d-info .transfer-accounts-d-text{
	    line-height: 18px;
	    height: 36px;
	    overflow: hidden;
	}
	.transfer-accounts-d .transfer-accounts-d-footer{
	    height: 20px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666666;
	    text-indent: 10px;
	}
	.comp-chatting-c-empty{
		padding: 20px;
		text-align: center;
		color: #999999;
	}
	/* 文件消息样式 */
	.chat-file{
		padding: 5px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 224px;
		height: auto;
		cursor: pointer;
	}
	.chat-file .chat-file-info{
		width: 0;
		flex-grow: 1;
		line-height: 18px;
		word-break: break-all;
	}
	.chat-file-info p:last-child{
		font-size: 12px;
		color: #999999;
	}
	.chat-file .chat-file-icon{
		width: 40px;
		height: 40px;
		margin-left: 20px;
		background-image: url(../assets/img/msg-file.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 32px auto;
	}
	.chat-file .chat-file-icon-txt{
		background-image: url(../assets/img/msg-txt.png) !important;
	}
	.chat-file .chat-file-icon-ppt{
		background-image: url(../assets/img/msg-ppt.png) !important;
	}
	.chat-file .chat-file-icon-pdf{
		background-image: url(../assets/img/msg-pdf.png) !important;
	}
	.chat-file .chat-file-icon-doc{
		background-image: url(../assets/img/msg-doc.png) !important;
	}
	.chat-file .chat-file-icon-xls{
		background-image: url(../assets/img/msg-xls.png) !important;
	}
	/* 链接消息样式 */
	.chat-link{
		width: 264px;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
	}
	.chat-link .chat-link-title{
		line-height: 20px;
		max-height: 40px;
		overflow: hidden;
		font-weight: 600;
		word-wrap: break-word;
		text-overflow: ellipsis;
		padding: 5px 5px 0 5px;
	}
	.chat-link .chat-link-info{
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		align-items: center;
		padding: 0 5px;
	}
	.chat-link-info p{
		flex-grow: 1;
		width: 0;
		max-height: 60px;
		overflow: hidden;
		font-size: 12px;
		color: #a6a6a6;
	}
	.chat-link-info img{
		width: 40px;
		height: 40px;
		margin-left: 10px;
	}
	.chat-link .chat-link-tip{
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
		align-items: center;
		border-top: 1px solid #dedede;
		margin: 0 5px;
	}
	.chat-link-tip img{
		height: 16px;
		width: auto;
		margin-right: 5px;
	}
	.chat-link-tip p{
		color: #999999;
		font-size: 12px;
		line-height: 20px;
	}
	/* 视频号消息样式 */
	.chat-finder{
		width: 220px;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
	}
	.chat-finder-img{
		width: 100%;
		height: auto;
		position: relative;
	}
	.chat-finder-img > .chat-finder-thumb{
		width: 100%;
		height: auto;
	}
	.chat-finder-img .chat-finder-play{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 40px;
		height: 40px;
	}
	.chat-finder-info{
		height: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 14px;
	}
	.chat-finder-info > img{
		width: 22px;
		height: 22px;
		display: block;
		margin: 0 5px;
		border-radius: 11px;
	}
	.chat-finder-desc{
		padding: 0 5px;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
	}
	.chat-finder-desc p{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.chat-finder-tip{
		border-top: 1px solid #EEEEEE;
		margin-top: 5px;
		padding: 5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 12px;
	}
	.chat-finder-tip > img{
		width: 18px;
		height: 18px;
		display: block;
		margin: 0 5px;
	}
</style>
